import { EstimateTexts, FacePaintingCalculator } from '../artifacts/FacePaintingEstimate.js';

// Live update of views/pages/face-painting/calculator.ejs. The bundle runs on
// every page; only the face-painting page has the calculator.
(() => {
    const root = document.querySelector<HTMLElement>('[data-face-painting-calculator]');
    if (!root) {
        return;
    }
    const { config, texts } = root.dataset;
    const input = root.querySelector<HTMLInputElement>('.fp-calc__children');
    const hours = root.querySelector<HTMLElement>('[data-result="hours"]');
    const cost = root.querySelector<HTMLElement>('[data-result="cost"]');
    if (!config || !texts || !input || !hours || !cost) {
        throw new Error('face-painting-calculator: markup does not match views/pages/face-painting/calculator.ejs');
    }
    const calculator = new FacePaintingCalculator(JSON.parse(config));
    const estimateTexts: EstimateTexts = JSON.parse(texts);
    const min = Number(input.min);
    const max = Number(input.max);

    const update = () => {
        const children = Math.round(Number(input.value));
        // Empty or out-of-range input while typing: keep the last result.
        if (!input.value || children < min || children > max) {
            return;
        }
        const result = calculator.format(children, estimateTexts);
        hours.textContent = result.hours;
        cost.textContent = result.cost;
    };

    input.addEventListener('input', update);
    for (const button of root.querySelectorAll<HTMLButtonElement>('[data-step]')) {
        button.addEventListener('click', () => {
            const current = Math.round(Number(input.value)) || calculator.config.defaultChildren;
            input.value = String(Math.min(max, Math.max(min, current + Number(button.dataset.step))));
            update();
        });
    }
})();
